/**
 * @file: editWindow.ts
 *
 * The single source of truth for the message-edit time window. An own
 * plain-text message is editable only within this window of its creation —
 * mirrors the server's author-only edit rule (a doomed edit isn't offered, and
 * a stale edit is blocked at submit), so keep this in sync with the backend.
 */

export const CHAT_EDIT_WINDOW_MS = 5 * 60 * 1000;

export const isWithinEditWindow = (createdAt: string): boolean =>
  Date.now() - new Date(createdAt).getTime() < CHAT_EDIT_WINDOW_MS;
